// extracted by mini-css-extract-plugin
export default {"content":"styles_content__EbQuS","replyingTo":"styles_replyingTo__YapbI","updateButton":"styles_updateButton__k2-+i"};